<div class="batman-wrapper" *ngIf="landingPageProps">
  <div class="hero-wrapper batman-theme" *ngIf="partialRender.hero">
    <flo-funnel-checkout-header
      [showDarkLogo]="false"
      [showPrompt]="landingPageProps.showLoginPrompt"
      [analyticsProps]="analyticsProps"
    ></flo-funnel-checkout-header>
    <flo-batman-hero [landingPageProps]="landingPageProps" [analyticsProps]="analyticsProps">
    </flo-batman-hero>
  </div>

  <!-- Up Next section -->
 <flo-event-card-scroll [eventCardContainer]="upNextContent$ | async" [geoBlockedIds]="geoBlockedIds$ | async" data-test="event-card-scroll"></flo-event-card-scroll>

  <div *ngIf="partialRender.carousel" class="batman-container features-wrapper">
    <flo-batman-features
      [carouselBackgroundGen]="carouselBackgroundGen"
      [carouselData]="carouselData"
      [showCarousel]="showCarousel"
      [siteId]="landingPageProps.siteSettings.site_id"
    ></flo-batman-features>
  </div>
  <div
    *ngIf="partialRender.devices"
    class="batman-lower-container devices-container"
    data-test="checkout-devices-container"
  >
    <h2 class="batman-header funnel-title">Watch anytime, on any device.</h2>
    <p class="batman-subheader funnel-subheader">
      Watch on any web browser or the FloSports app — available on the following
      platforms.
    </p>
    <flo-offered-devices></flo-offered-devices>
  </div>
  <div
    *ngIf="partialRender.faq"
    class="batman-lower-container faq-container"
    data-test="checkout-faq-container"
  >
    <flo-faq-section [header]="'Frequently Asked Questions'" [siteSettings]="landingPageProps.siteSettings"></flo-faq-section>
  </div>
</div>
